var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgModifica(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_4890",
    "data-name": "Raggruppa 4890",
    transform: "translate(-4508 -2421)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellisse_250",
    "data-name": "Ellisse 250",
    cx: 14,
    cy: 14,
    r: 14,
    transform: "translate(4508 2421)",
    fill: "#387fdf"
  }), /*#__PURE__*/React.createElement("g", {
    id: "noun-edit-7188629",
    transform: "translate(4505.471 2417.177)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_9625",
    "data-name": "Tracciato 9625",
    d: "M24.363,13.85l-4.941,4.941a.557.557,0,0,1-.093.06l-1.746.655a.145.145,0,0,1-.027.007.057.057,0,0,1-.053-.086l.655-1.746a.457.457,0,0,1,.06-.093l4.941-4.941a.226.226,0,0,1,.172-.073.178.178,0,0,1,.132.047l.926.926a.227.227,0,0,1-.027.3Zm-4.8,5.622-1.746.655-.139.047h-.119a.723.723,0,0,1-.675-.986l.655-1.74a.922.922,0,0,1,.212-.331l3.228-3.228H13.19a.663.663,0,0,0-.661.661v9.261a.663.663,0,0,0,.661.661h9.261a.663.663,0,0,0,.661-.661V16.033l-3.221,3.221a1,1,0,0,1-.331.219Z",
    transform: "translate(-1.403 -1)",
    fill: "#fff"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgModifica);
export default __webpack_public_path__ + "static/media/modifica.77529e140c60ac97d3710e77cca6a7f2.svg";
export { ForwardRef as ReactComponent };